export default {
	datatable: {
		expand: 'Show more',
		filterData: 'Filter data',
		sendCredentials: {
			title: 'Send Login Credentials',
			confirm:
				'Please confirm that the following {count} user(s) will receive a welcome email. The existing password will be overwritten.',
			selectRecipients: 'Select Recipients',
			warningExternal:
				'Please note that this notification will also be sent to people specified as external witnesses, even if they have not accepted the Terms of Use and Privacy Policy for HausPerfekt MOBILE.',
			additionalInfo: 'Additional Information',
			send: 'Send',
			choiceInfo:
				'Please choose whether all users or only users with an active person role should receive a welcome email.',
			choiceExtra:
				'Additionally, choose whether only users who have not logged in before should receive a welcome email.',
			allUsers: 'All Users',
			activeUsers: 'Users with an Active Person Role',
			neverLoggedIn: 'Without Prior Login',
		},
	},
}
